import { gql } from "@apollo/client";

const EMPLOYEE_FRAGMENT_FIELDS = gql`
  fragment EmployeeBasicDetails on Employee {
    user {
      email
      id
      firstName
      lastName
    }
    lastName
    id
    phone
    firstName
    middleName
    emailAddress
    ssn
    gender
    birthday
    homeAddress
    homeAddress2
    homeAddressCity
    homeAddressState
    homeAddressZip
    isHomeSameMailingAddress
    mailingAddress
    mailingAddress2
    mailingAddressCity
    mailingAddressState
    mailingAddressZip
    businessUnits {
      id
      name
    }
  }
`;

export const EMPLOYEE_LIST = gql`
  query EmployeeList($empId: ID) {
    employeesList(filter: { id: { equals: $empId } }) {
      items {
        ...EmployeeBasicDetails
      }
    }
  }
  ${EMPLOYEE_FRAGMENT_FIELDS}
`;

export const EMPLOYEE_LIST_SEARCH = gql`
  query EmployeeListSearch($filter: EmployeeFilter) {
    employeesList(filter: $filter) {
      items {
        ...EmployeeBasicDetails
      }
    }
  }
  ${EMPLOYEE_FRAGMENT_FIELDS}
`;

export const EMPLOYEE_INFO_OLD = gql`
  query EmployeeList($id: ID) {
    employeesList(filter: { id: { equals: $id } }) {
      items {
        ...EmployeeBasicDetails
        services {
          items {
            id
            service
            isActive
          }
        }

        referral {
          id
          firstName
          lastName
        }
        hearAboutUs
        status
      license_number
        license_expiration_date
      }
    }
  }
  ${EMPLOYEE_FRAGMENT_FIELDS}
`;
export const EMPLOYEE_INFO = gql`
  query EmployeeList($filter: EmployeeFilter!) {
    employeesList(filter: $filter) {
      items {
        ...EmployeeBasicDetails
        services {
          items {
            id
            service
            isActive
          }
        }

        referral {
          id
          firstName
          lastName
        }
        hearAboutUs
        status
        license_number
        license_expiration_date
      }
    }
  }
  ${EMPLOYEE_FRAGMENT_FIELDS}
`;

export const EMPLOYEE_REVIEW_LIST = gql`
  query EmployeeReviewsList($empId: ID!) {
    employeeReviewsList(filter: { employee: { id: { equals: $empId } } }) {
      items {
        id
        notes
        reviewDate
        attachment {
          downloadUrl
          filename
          id
        }
      }
    }
  }
`;
export const ADD_BULK_EMPLOYEE_REVIEW = gql`
  mutation AddBulkEmployeeReview($data: [EmployeeReviewCreateManyInput]!) {
    employeeReviewCreateMany(data: $data) {
      items {
        id
      }
    }
  }
`;
export const ADD_EMPLOYEE_REVIEW = gql`
  mutation AddEmployeeReview($data: EmployeeReviewCreateInput!) {
    employeeReviewCreate(data: $data) {
      id
    }
  }
`;

export const UPDATE_EMPLOYEE_REVIEW = gql`
  mutation UpdateEmployeeReview($data: EmployeeReviewUpdateInput!) {
    employeeReviewUpdate(data: $data) {
      id
    }
  }
`;
export const DELETE_REVIEW = gql`
  mutation DeleteReview($id: ID) {
    employeeReviewDeleteByFilter(filter: { id: { equals: $id } }) {
      success
    }
  }
`;

export const ADD_EMPLOYEE = gql`
  mutation EmployeeCreate($data: EmployeeCreateInput!) {
    employeeCreate(data: $data) {
      id
    }
  }
`;

export const UPDATE_EMPLOYEE = gql`
  mutation EmployeeCreate($data: EmployeeUpdateInput!) {
    employeeUpdate(data: $data) {
      id
    }
  }
`;

export const UPDATE_EMPLOYEE_AND_USER_EMAIL = gql`
  mutation UpdateEmployeeAndUserEmail(
    $employeeId: ID!
    $newEmailAddress: String!
    $updateUserLogin: Boolean!
  ) {
    updateEmployeeAndUserEmail(
      employeeId: $employeeId
      newEmailAddress: $newEmailAddress
      updateUserLogin: $updateUserLogin
    ) {
      success
      message
      auth0Recreated
    }
  }
`;
export const ADD_EMPLOYEE_ACTIVITY = gql`
  mutation AddEmployeeActivity($data: EmployeeEmploymentInfoCreateInput!) {
    employeeEmploymentInfoCreate(data: $data) {
      id
    }
  }
`;

export const UPDATE_EMPLOYEE_ACTIVITY = gql`
  mutation UpdateEmployeeActivity($data: EmployeeEmploymentInfoUpdateInput!) {
    employeeEmploymentInfoUpdate(data: $data) {
      id
    }
  }
`;

export const DELETE_EMPLOYEE_ACTIVITY = gql`
  mutation DeleteEmploymentInfo($id: ID) {
    employeeEmploymentInfoDelete(filter: { id: $id }) {
      success
    }
  }
`;

//

export const CONTACT_LISTS = gql`
  query EmployeeContacts($filter: EmergencyContactFilter!) {
    emergencyContactsList(filter: $filter, sort: { order: ASC }) {
      items {
        id
        employee {
          items {
            lastName
            id
            emailAddress
            firstName
            phone
          }
        }
        relationship
        contacts {
          items {
            firstName
            lastName
            id
            email
            phone
            cellPhone
          }
        }
        order
      }
    }
  }
`;
export const AVAILABLE_EMERGENCY_LIST = gql`
  query AvailableContacts($id: ID!) {
    contactsList(
      filter: {
        emergencyContacts: {
          every: { employee: { none: { id: { equals: $id } } } }
        }
      }
    ) {
      items {
        email
        lastName
        firstName
        id
        phone
        emergencyContacts {
          items {
            id
            relationship
          }
        }
      }
    }
  }
`;

//  Temp. used - delete soon...
export const UPDATE_EMPLOYEE_EMERGENCY_VIA_ID = gql`
  mutation CreateEmergencyContactViaID(
    $empID: ID!
    $contacts: ID!
    $relationship: String!
    $emergencyType: String!
  ) {
    emergencyContactCreate(
      data: {
        contacts: { connect: { id: $contacts } }
        employee: { connect: { id: $empID } }
        relationship: $relationship
        emergencyType: $emergencyType
      }
    ) {
      id
    }
  }
`;

export const ADD_EMPLOYEE_EMERGENCY_VIA_NEW_CONTACT = gql`
  mutation CreateEmergencyContact($data: EmergencyContactCreateInput!) {
    emergencyContactCreate(data: $data) {
      id
    }
  }
`;
export const UPDATE_EMPLOYEE_EMERGENCY_VIA_NEW_CONTACT = gql`
  mutation CreateEmergencyContact($data: EmergencyContactUpdateInput!) {
    emergencyContactUpdate(data: $data) {
      id
    }
  }
`;

export const DELETE_EMERGENCY_CONTACT = gql`
  mutation DeleteEmergencyContact($id: ID) {
    emergencyContactDelete(filter: { id: $id }) {
      success
    }
  }
`;

export const EMPLOYEE_DRIVING_LICENSE = gql`
  query EmployeeDrivingLicense($id: ID) {
    employee(id: $id) {
      license_expiration_date
      license_full_name
      license_issuing_state
      license_number
      license_type
    }
  }
`;

// export const EMPLOYEE_DRIVING_LICENSE = gql`
//   query EmployeeDrivingLicensesList($id: ID) {
//     employeeDrivingLicensesList(filter: { employee: { id: { equals: $id } } }) {
//       items {
//         id
//         notes
//         businessUnits {
//           id
//           name
//         }
//         fleetVehicles {
//           items {
//             id
//             name
//           }
//         }
//       }
//     }
//   }
// `;

// export const ADD_EMPLOYEE_DRIVING_LICENSE_old = gql`
//   mutation CreateEmployeeDrivingLicense(
//     $id: ID
//     $companyName: String
//     $notes: String
//   ) {
//     employeeDrivingLicenseCreate(
//       data: {
//         employee: { connect: { id: $id } }
//         companyName: $companyName
//         notes: $notes
//       }
//     ) {
//       id
//     }
//   }
// `;

// export const ADD_EMPLOYEE_DRIVING_LICENSE = gql`
//   mutation EmployeeDrivingLicenseCreate(
//     $data: EmployeeDrivingLicenseCreateInput!
//   ) {
//     employeeDrivingLicenseCreate(data: $data) {
//       id
//     }
//   }
// `;

// export const UPDATE_EMPLOYEE_DRIVING_LICENSE_old = gql`
//   mutation UpdateEmployeeDrivingLicense(
//     $id: ID
//     $companyName: String
//     $notes: String
//   ) {
//     employeeDrivingLicenseUpdate(
//       data: { companyName: $companyName, notes: $notes }
//       filter: { id: $id }
//     ) {
//       id
//     }
//   }
// `;

// export const UPDATE_EMPLOYEE_DRIVING_LICENSE = gql`
//   mutation EmployeeDrivingLicenseUpdate(
//     $data: EmployeeDrivingLicenseUpdateInput!
//     $filter: EmployeeDrivingLicenseKeyFilter
//   ) {
//     employeeDrivingLicenseUpdate(data: $data, filter: $filter) {
//       id
//     }
//   }
// `;

// export const DELETE_EMPLOYEE_DRIVING_LICENSE = gql`
//   mutation DeleteDrivingLicense($id: ID) {
//     employeeDrivingLicenseDeleteByFilter(filter: { id: { equals: $id } }) {
//       success
//     }
//   }
// `;

// Employment Info

export const EMPLOYMENT_INFO_LIST = gql`
  query EmployeeEmploymentInfosList($id: ID) {
    employeeEmploymentInfosList(
      filter: { employee: { id: { equals: $id } } }
      sort: { createdAt: DESC }
    ) {
      items {
        id
        activityType
        notes
        startDate
        endDate
        specificLeave
        document {
          filename
          id
          downloadUrl
        }
      }
    }
  }
`;

export const ADD_EMPLOYMENT_INFO = gql`
  mutation CreateEmployeeEmploymentInfo(
    $id: ID
    $endDate: Date
    $hireDate: Date
    $leaveOfAbsence: String
    $notes: String
    $rehiredDate: Date
    $startDate: Date
    $terminationDate: Date
  ) {
    employeeEmploymentInfoCreate(
      data: {
        employee: { connect: { id: $id } }
        endDate: $endDate
        hireDate: $hireDate
        leaveOfAbsence: $leaveOfAbsence
        notes: $notes
        rehiredDate: $rehiredDate
        startDate: $startDate
        terminationDate: $terminationDate
      }
    ) {
      id
    }
  }
`;

// Employment Info
// Business Unit
export const BUSINESS_UNIT_LIST = gql`
  query BusinessUnitsList {
    businessUnitsList {
      items {
        id
        name
        fleetVehicles {
          items {
            name
            id
          }
        }
      }
    }
  }
`;

// Business Unit

// Review

export const REVIEW_LIST = gql`
  query EmployeeReviewsList($id: ID) {
    employeeReviewsList(filter: { employee: { id: { equals: $id } } }) {
      items {
        id
        reviewDate
        notes
      }
    }
  }
`;

// Review

// Permits

export const ADD_BULK_PERMIT = gql`
  mutation AddBulkPermits($data: [EmployeePermitCreateManyInput]!) {
    employeePermitCreateMany(data: $data) {
      items {
        id
      }
    }
  }
`;

export const PERMIT_LIST = gql`
  query EmployeePermitsList($id: ID!, $permit: String) {
    employeePermitsList(
      filter: {
        employee: { id: { equals: $id } }
        permitType: { equals: $permit }
      }
    ) {
      items {
        id
        permitType
        permitNum
        expirationDate
        requalificationDate
        certificateNum
        completionDate
        instructorName
        firearmMake
        fireArmModel
        fireArmSerial
        batonInstructorCertificateNum
        cprIssueDate
        cprRenewBy
        psOfficerName
        psInstructorLicNum
        gcNumber
        attachments {
          items {
            downloadUrl
            filename
            id
            previewUrl
            public
          }
        }
      }
    }
  }
`;
export const PERMIT_ALL_LIST = gql`
  query EmployeePermitsList($id: ID!) {
    employeePermitsList(filter: { employee: { id: { equals: $id } } }) {
      items {
        id
        permitType
      }
    }
  }
`;

export const ADD_PERMITS = gql`
  mutation AddPermit($data: EmployeePermitCreateInput!) {
    employeePermitCreate(data: $data) {
      id
    }
  }
`;

export const UPDATE_PERMITS = gql`
  mutation UpdatePermit($data: EmployeePermitUpdateInput!) {
    employeePermitUpdate(data: $data) {
      id
    }
  }
`;

export const DELETE_PERMITS = gql`
  mutation DeletePermit($id: ID!) {
    employeePermitDeleteByFilter(filter: { id: { equals: $id } }) {
      success
    }
  }
`;

// Permits

// Guard Card
export const ADD_BULK_GUARD_CARD = gql`
  mutation AddBulkGuardCard($data: [EmployeeGuardCardCreateManyInput]!) {
    employeeGuardCardCreateMany(data: $data) {
      items {
        id
      }
    }
  }
`;

export const GUARD_CARD_LIST = gql`
  query EmployeeGuardList($id: ID!) {
    employeeGuardCardsList(filter: { employee: { id: { equals: $id } } }) {
      items {
        id
        expirationDate
        gcNumber
      }
    }
  }
`;

export const ADD_GUARD_CARD = gql`
  mutation AddGuardCard($data: EmployeeGuardCardCreateInput!) {
    employeeGuardCardCreate(data: $data) {
      id
    }
  }
`;

export const UPDATE_GUARD_CARD = gql`
  mutation UpdateGuardCard($data: EmployeeGuardCardUpdateInput!) {
    employeeGuardCardUpdate(data: $data) {
      id
    }
  }
`;

export const DELETE_GUARD_CARD = gql`
  mutation DeleteGuardCard($id: ID!) {
    employeeGuardCardDeleteByFilter(filter: { id: { equals: $id } }) {
      success
    }
  }
`;

// Guard Card

// subscriptions
export const SUBSCRIBE_TO_EMPLOYEE_UPDATES = gql`
  subscription EmployeeUpdatesSubscription($id: ID!) {
    Employee(filter: { node: { id: { equals: $id } } }) {
      mutation
      node {
        _description
        id
        birthday
        createdAt
        emailAddress
        firstName
        gender
        hearAboutUs
        homeAddress
        middleName
        lastName
      }
    }
  }
`;

//

export const EMPLOYEE_CREATE_USER_ACCOUNT = gql`
  mutation EmployeeCreateUserAccount($id: ID!, $empId: ID!) {
    employeeUpdate(
      data: { user: { connect: { id: $id } } }
      filter: { id: $empId }
    ) {
      id
      status
    }
  }
`;

export const EMPLOYEE_REFUSED_SITE = gql`
  query EmployeeRefusedSites($empId: ID!) {
    employee(id: $empId) {
      id
      employeeRefused {
        items {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_EMPLOYEE_REFUSED_SITE = gql`
  mutation RemoveSiteRefused($empID: ID!, $id: ID) {
    employeeUpdate(
      data: { employeeRefused: { disconnect: { id: $id } } }
      filter: { id: $empID }
    ) {
      id
    }
  }
`;
export const ADD_EMPLOYEE_REFUSED_SITE = gql`
  mutation RemoveSiteRefused($empID: ID!, $id: ID!) {
    employeeUpdate(
      data: { employeeRefused: { connect: { id: $id } } }
      filter: { id: $empID }
    ) {
      id
    }
  }
`;

// export const EMPLOYEE_BANNED_SITE = gql`
//   query EmployeeRefusedSites($empId: ID!) {
//     employeesList(filter: { id: { equals: $empId } }) {
//       items {
//         id
//         firstName
//         lastName
//         emailAddress
//         bannedEmployee {
//           items {
//             id
//             name
//           }
//         }
//       }
//     }
//   }
// `;
export const EMPLOYEE_SITES_NOT_REFUSED = gql`
  query EmployeeSitesNotBanned($empID: ID!) {
    sitesList(
      filter: { employeeRefused: { none: { id: { equals: $empID } } } }
    ) {
      items {
        id
        name
      }
    }
  }
`;

// Banned
export const EMPLOYEE_BANNED_SITE = gql`
  query EmployeeBannedSites($empId: ID!) {
    employee(id: $empId) {
      id
      bannedEmployee {
        items {
          id
          name
        }
      }
    }
  }
`;
export const DELETE_EMPLOYEE_BANNED_SITE = gql`
  mutation RemoveSiteRefused($empID: ID!, $id: ID) {
    employeeUpdate(
      data: { bannedEmployee: { disconnect: { id: $id } } }
      filter: { id: $empID }
    ) {
      id
    }
  }
`;

export const EMPLOYEE_SITES_NOT_BANNED = gql`
  query EmployeeSitesNotBanned($empID: ID!) {
    sitesList(
      filter: { bannedEmployee: { none: { id: { equals: $empID } } } }
    ) {
      items {
        id
        name
      }
    }
  }
`;
export const ADD_EMPLOYEE_BANNED_SITE = gql`
  mutation RemoveSiteRefused($empID: ID!, $id: ID!) {
    employeeUpdate(
      data: { bannedEmployee: { connect: { id: $id } } }
      filter: { id: $empID }
    ) {
      id
    }
  }
`;

/// SITES

export const SITE_REFUSED_EMPLOYEES = gql`
  query SitesRefusedEmployees($siteId: ID!) {
    site(id: $siteId) {
      id
      employeeRefused {
        items {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
export const SITE_BANNED_EMPLOYEES = gql`
  query SiteBannedEmployees($siteId: ID!) {
    site(id: $siteId) {
      id
      bannedEmployee {
        items {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
export const EMPLOYEE_NOT_BANNED_SITES = gql`
  query EmployeeSitesNotBanned($siteId: ID!) {
    employeesList(
      filter: { bannedEmployee: { none: { id: { equals: $siteId } } } }
    ) {
      items {
        id
        firstName
        lastName
      }
    }
  }
`;
export const EMPLOYEE_NOT_REFUSED_SITES = gql`
  query EmployeeSitesNotBanned($siteId: ID!) {
    employeesList(
      filter: { employeeRefused: { none: { id: { equals: $siteId } } } }
    ) {
      items {
        id
        firstName
        lastName
      }
    }
  }
`;

export const ADD_EMPLOYEE_REFUSED_TO_SITE = gql`
  mutation RemoveSiteRefused($siteId: ID!, $empId: ID!) {
    siteUpdate(
      data: { employeeRefused: { connect: { id: $empId } } }
      filter: { id: $siteId }
    ) {
      id
    }
  }
`;
export const ADD_EMPLOYEE_BANNED_TO_SITE = gql`
  mutation RemoveSiteRefused($siteId: ID!, $empId: ID!) {
    siteUpdate(
      data: { bannedEmployee: { connect: { id: $empId } } }
      filter: { id: $siteId }
    ) {
      id
    }
  }
`;

export const DELETE_EMPLOYEE_REFUSED_TO_SITE = gql`
  mutation RemoveSiteRefused($siteId: ID!, $empId: ID!) {
    siteUpdate(
      data: { employeeRefused: { disconnect: { id: $empId } } }
      filter: { id: $siteId }
    ) {
      id
    }
  }
`;
export const DELETE_EMPLOYEE_BANNED_TO_SITE = gql`
  mutation RemoveSiteRefused($siteId: ID!, $empId: ID) {
    siteUpdate(
      data: { bannedEmployee: { disconnect: { id: $empId } } }
      filter: { id: $siteId }
    ) {
      id
    }
  }
`;
/// SITES
